<template>
  <div :class="d._class" :id="d.title">
    <div class="container">
      <h3>{{d.title}}</h3>
      <div style="margin: 5% 0">
        <h3 style="font-size:1.5em">Organizing Committee</h3>
        <div class="agile_team_grids">
          <div class="col-md-4 agile_team_grid" v-for="(x, i) of d.organizingCommittee" :key="i">
            <div class="view w3-agile-view" style="margin:auto">
              <img :src="x.avatar" alt=" " class="img-responsive" />
              <div class="w3lmask" style="padding-top: 80%">
                <p>{{x.brief}}</p>
              </div>
            </div>
            <h4>
              <a :href="x.homepage">{{x.name}}</a>
            </h4>
          </div>

          <div class="clearfix"></div>
        </div>
      </div>
      <!-- <div style="margin: 5% 0"> -->
        <!-- <h3 style="font-size:1.5em">Program Committee</h3> -->
        <!-- <table class="table table-striped" style="margin:3em 0">
                        <tbody>
                            <tr>
                                <td>Chang Xu</td>
                                <td>Nanjing University</td>
                            </tr>
                            <tr>
                                <td>Xiaobing Sun</td>
                                <td>Yangzhou University</td>
                            </tr>
                            <tr>
                                <td>Weiyi Shang</td>
                                <td>Concordia University</td>
                            </tr>
                            <tr>
                                <td>Eunjong Choi</td>
                                <td>Kyoto Institute of Technology</td>
                            </tr>
                            <tr>
                                <td>Jifeng Xuan</td>
                                <td>Wuhan University</td>
                            </tr>
                            <tr>
                                <td>Jinfu Chen</td>
                                <td>Concordia University</td>
                            </tr>
                            <tr>
                                <td>Jingxuan Zhang</td>
                                <td>Nanjing University of Aeronautics and Astronautics</td>
                            </tr>
                            <tr>
                                <td>Jing Jiang</td>
                                <td>Beihang University</td>
                            </tr>
                            <tr>
                                <td>Shin Hong</td>
                                <td>Handong Global University</td>
                            </tr>
                            <tr>
                                <td>Lingfeng Bao</td>
                                <td>Zhejiang University</td>
                            </tr>
                            <tr>
                                <td>Hao Zhong</td>
                                <td>Shanghai Jiao Tong University</td>
                            </tr>
                            <tr>
                                <td>Lu Xiao</td>
                                <td>Stevens Institute of Technology</td>
                            </tr>
                            <tr>
                                <td>Jinqiu Yang</td>
                                <td>Concordia University</td>
                            </tr>
                            <tr>
                                <td>Chunrong Fang</td>
                                <td>Software Institute of Nanjing University</td>
                            </tr>
                            <tr>
                                <td>Jürgen Cito</td>
                                <td>MIT</td>
                            </tr>
                            <tr>
                                <td>Xiaoyuan Xie</td>
                                <td>Wuhan University</td>
                            </tr>
                            <tr>
                                <td>Tao Zhang</td>
                                <td>Macau University of Science and Technology</td>
                            </tr>
                            <tr>
                                <td>Yan Cai</td>
                                <td>State Key Laboratory of Computer Science,Institute of Software,Chinese Academy of Sciences</td>
                            </tr>
                            <tr>
                                <td>Heng Li</td>
                                <td>Queen's University</td>
                            </tr>
                            <tr>
                                <td>Donghwan Shin</td>
                                <td>University of Luxembourg</td>
                            </tr>
                            <tr>
                                <td>Ying Wang</td>
                                <td>Northeastern University</td>
                            </tr>
                            <tr>
                                <td>Yepang Liu</td>
                                <td>Southern University of Science and Technology</td>
                            </tr>
                            <tr>
                                <td>Lei Ma</td>
                                <td>Kyushu University</td>
                            </tr>
                            <tr>
                                <td>He Jiang</td>
                                <td>Dalian University of Technology</td>
                            </tr>
                            <tr>
                                <td>Xiapu Luo</td>
                                <td>The Hong Kong Polytechnic University</td>
                            </tr>
                            <tr>
                                <td>Patanamon Thongtanunam</td>
                                <td>The University of Melbourne</td>
                            </tr>
                            <tr>
                                <td>Hui Liu</td>
                                <td>Beijing Institute of Technology</td>
                            </tr>
                        </tbody>
        </table>-->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Organization",
  props: {
    datum: {
      type: Object,
      default: function() {
        return {
          organizingCommittee: [],
          programCommittee: []
        };
      }
    }
  },
  data() {
    return {
      d: {
        _class: "team",
        title: "Organization",
        ...this.datum
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Organization.vue